module.exports = __webpack_public_path__ + "img/back_300.090c2b94.png";